import * as React from "react";
import {
  NumberInput as ChakraNumberInput,
  NumberInputField,
  NumberInputFieldProps,
  NumberInputProps as ChakraNumberInputProps
} from "@chakra-ui/react";
import { generateId, useField } from "duck";
import { Types } from "../../duck";
import InputLayout from "../input-layout";

interface NumberInputProps
  extends Omit<ChakraNumberInputProps, "onChange">,
    Types.BaseInputProps {
  getValueLabel?(value: string): string;
  onChange?(value: number | string | null): void;
  inputFieldProps?: NumberInputFieldProps;
}

const NumberInput: React.FC<NumberInputProps> = ({
  name,
  label,
  labelHidden,
  inputLayoutProps,
  placeholder,
  getValueLabel,
  value,
  onChange,
  onFocus,
  onBlur,
  inputFieldProps,
  defaultValue,
  ...rest
}) => {
  const labelId = React.useMemo(() => name || generateId(), [name]);

  const [focused, setFocused] = React.useState(false);

  const fieldProps = useField(name);

  const valueToUse = fieldProps.value === null ? "" : fieldProps.value;

  return (
    <InputLayout
      label={label}
      labelHidden={labelHidden}
      errorMessage={fieldProps.error}
      id={labelId}
      {...inputLayoutProps}
      input={
        <ChakraNumberInput
          name={labelId}
          defaultValue={defaultValue}
          value={
            valueToUse !== "" && valueToUse != null && getValueLabel && !focused
              ? getValueLabel(valueToUse)
              : valueToUse
          }
          onChange={vl => {
            const newValue = vl === "" ? null : vl;

            if (onChange) {
              onChange(newValue);
            } else if (fieldProps.onChange) {
              fieldProps.onChange(newValue);
            }
          }}
          onFocus={event => {
            setFocused(true);
            if (onFocus) {
              onFocus(event);
            }
          }}
          onBlur={event => {
            setFocused(false);
            if (onBlur) {
              onBlur(event);
            } else if (fieldProps.onBlur) {
              fieldProps.onBlur();
            }
          }}
          onKeyDown={event => {
            if (event.key === "e") {
              event.preventDefault();
            }
          }}
          {...rest}
        >
          <NumberInputField
            {...inputFieldProps}
            placeholder={placeholder}
            ref={fieldProps.ref}
          />
        </ChakraNumberInput>
      }
    />
  );
};

export default NumberInput;
